module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/pleasant/4f1e56e80135cb7be45e559340c6c493.png";